import type { GeoPoint } from 'tripPlanner/types/placeAndDateTime'

interface DrawerOpening {
  stopCoordinates?: GeoPoint
  initialSelectedOfferId?: string
}

// Mirrors the drawer's first view: an initial offer opens its detail, and no coordinates means no Places tab.
export function opensOnThingsToDo({ stopCoordinates, initialSelectedOfferId }: DrawerOpening): boolean {
  return stopCoordinates !== undefined && initialSelectedOfferId === undefined
}
